import React from "react";
import { ConnectButton } from '@rainbow-me/rainbowkit';
import logo from "../../images";

const Header = () => {

  return (
    <nav className=" w-full bg-lgreen">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto px-4">
        <a href="https://t.me/safeonechain" target="_blank" rel="noreferrer">
          <img
            src={logo}
            alt="safo"
            className="w-30 h-20 cursor-pointer rounded-xl"
          />
        </a>
        <div className="flex md:order-2 mr-12 md:mr-0">

          <ConnectButton accountStatus={"address"} chainStatus={"none"} />


        </div>

      </div>
    </nav>
  );
};

export default Header;
